export default {
  qingping_particle_sensor: '青萍顆粒物傳感器',
  design: '外觀',
  measurement_range: '量程',
  specs: '規格',
  in_the_box: '包裝清單',
  size: '尺寸',
  color: '顏色',
  size_value: '49.5 × 37 × 11.8 毫米',
  color_value: '銀色',
  pm25_pm10: 'PM2.5/PM10',
  pm_range: '0 ~ 999 μg/m³',
  name: '產品名稱',
  weight: '產品重量',
  weight_value: '26 克',
  mm_unit: '毫米'
} 